module.exports = __webpack_public_path__ + "static/media/ajout-message.be5b5ecc.png";